import { RouteConfig } from 'vue-router';

import { AttachmentType } from '@/enums/attachmentType.enum';
import { TableName } from '@/enums/tableName';
import store from '@/store/store';
import { prepareDocumentPackQuery } from '@/utils/prepareDocumentPackQuery';
import DocumentPacks from '@/views/mainRoute/procedure/packs/DocumentPacks.vue';

export const documentPacksRoute: RouteConfig = {
  path: 'packs',
  name: 'documentPacks',
  component: DocumentPacks,
  beforeEnter: (to, from, next) => {
    if (from.name !== 'documentPacks' && to.query.order) {
      return next({ ...to, query: { ...to.query, order: undefined, desc: undefined } });
    }
    Promise.all([
      store.dispatch('documentPack/list', prepareDocumentPackQuery(to)),
      store.dispatch('procedure/attachment/list', {
        order: 'order',
        desc: false,
        count: -1,
        entityType: TableName.procedure,
        entityId: to.params.procedureId.toString(),
        type: AttachmentType.GENERATED
      })
    ]).then(() => next());
  }
};
